export const functionalCookieName = 'consent_functional';
export const statisticsCookieName = 'consent_statistics';
export const functionalConsentEvent = 'functionalCookieConsent';
export const statisticsConsentEvent = 'statisticsCookieConsent';
export const statisticsConsentDenyEvent = 'statisticsCookieDeny';
